import ScheduledMessagesAPI from '../../api/scheduledMessages';

export const state = {
  records: {}, // keyed by conversationId (display_id)
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getScheduledMessages: _state => conversationId => {
    const records = _state.records[conversationId] || [];
    return [...records].sort(
      (a, b) => new Date(a.scheduled_at) - new Date(b.scheduled_at)
    );
  },
  getCount: _state => conversationId =>
    (_state.records[conversationId] || []).length,
  getUIFlags: _state => _state.uiFlags,
};

export const actions = {
  async get({ commit }, { conversationId }) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await ScheduledMessagesAPI.get(conversationId);
      commit('SET_RECORDS', { conversationId, data });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async create({ commit }, { conversationId, content, scheduledAt }) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const { data } = await ScheduledMessagesAPI.create(conversationId, {
        content,
        scheduledAt,
      });
      commit('ADD_RECORD', { conversationId, data });
      return data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  async update(
    { commit },
    { conversationId, scheduledMessageId, content, scheduledAt }
  ) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const { data } = await ScheduledMessagesAPI.update(
        conversationId,
        scheduledMessageId,
        { content, scheduledAt }
      );
      commit('EDIT_RECORD', { conversationId, data });
      return data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  async delete({ commit }, { conversationId, scheduledMessageId }) {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await ScheduledMessagesAPI.delete(conversationId, scheduledMessageId);
      commit('DELETE_RECORD', { conversationId, scheduledMessageId });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },
};

export const mutations = {
  SET_UI_FLAG(_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  SET_RECORDS(_state, { conversationId, data }) {
    _state.records = { ..._state.records, [conversationId]: data };
  },
  ADD_RECORD(_state, { conversationId, data }) {
    const records = _state.records[conversationId] || [];
    _state.records = {
      ..._state.records,
      [conversationId]: [...records, data],
    };
  },
  EDIT_RECORD(_state, { conversationId, data }) {
    const records = _state.records[conversationId] || [];
    const index = records.findIndex(r => r.id === data.id);
    if (index !== -1) {
      const updated = [...records];
      updated[index] = data;
      _state.records = { ..._state.records, [conversationId]: updated };
    }
  },
  DELETE_RECORD(_state, { conversationId, scheduledMessageId }) {
    const records = _state.records[conversationId] || [];
    _state.records = {
      ..._state.records,
      [conversationId]: records.filter(r => r.id !== scheduledMessageId),
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
